var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChoicePolicyActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#FFF6D6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6665 10.6663C19.2865 10.6663 19.5965 10.6663 19.8508 10.7345C20.541 10.9194 21.0801 11.4585 21.265 12.1487C21.3332 12.403 21.3332 12.713 21.3332 13.333V19.4663C21.3332 20.5864 21.3332 21.1465 21.1152 21.5743C20.9234 21.9506 20.6175 22.2566 20.2412 22.4484C19.8133 22.6663 19.2533 22.6663 18.1332 22.6663H13.8665C12.7464 22.6663 12.1863 22.6663 11.7585 22.4484C11.3822 22.2566 11.0762 21.9506 10.8845 21.5743C10.6665 21.1465 10.6665 20.5864 10.6665 19.4663V13.333C10.6665 12.713 10.6665 12.403 10.7347 12.1487C10.9196 11.4585 11.4587 10.9194 12.1489 10.7345C12.4032 10.6663 12.7132 10.6663 13.3332 10.6663M13.9998 17.9997L15.3332 19.333L18.3332 16.333M14.3998 11.9997H17.5998C17.9732 11.9997 18.1599 11.9997 18.3025 11.927C18.4279 11.8631 18.5299 11.7611 18.5938 11.6357C18.6665 11.4931 18.6665 11.3064 18.6665 10.933V10.3997C18.6665 10.0263 18.6665 9.83962 18.5938 9.69701C18.5299 9.57157 18.4279 9.46959 18.3025 9.40567C18.1599 9.33301 17.9732 9.33301 17.5998 9.33301H14.3998C14.0265 9.33301 13.8398 9.33301 13.6972 9.40567C13.5717 9.46959 13.4697 9.57157 13.4058 9.69701C13.3332 9.83962 13.3332 10.0263 13.3332 10.3997V10.933C13.3332 11.3064 13.3332 11.4931 13.4058 11.6357C13.4697 11.7611 13.5717 11.8631 13.6972 11.927C13.8398 11.9997 14.0265 11.9997 14.3998 11.9997Z",
    stroke: "#FFC72C",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoicePolicyActive);
export default __webpack_public_path__ + "static/media/choice-policy-active.16a758cc463bb71fcff93c71c70be506.svg";
export { ForwardRef as ReactComponent };